import { ShareBand, ShareFacebook, ShareKakao, ShareX } from '@viewup/ui';

export const kakaoScript = (url: string) => {
  const script = document.createElement('script');

  script.src = url;
  script.async = true;
  script.crossOrigin = 'anonymous';

  document.body.appendChild(script);

  return () => {
    document.body.removeChild(script);
  };
};

export const shareButtons = [
  {
    image: <ShareKakao />,
    onClick: () => {
      if ((window as any).Kakao) {
        const kakao = (window as any).Kakao;

        if (!kakao.isInitialized()) {
          kakao.init(process.env.NEXT_PUBLIC_KAKAO_API_KEY);
        }

        kakao.Share.sendDefault({
          content: {
            description: '#뷰업 #단순부업서비스 #적립',
            imageUrl: '/Logo/ViewupLogo.svg',
            link: {
              mobileWebUrl: window.location.href,
              webUrl: window.location.href,
            },
            title: '뷰업',
          },
          objectType: 'feed',
        });
      }
    },
    platform: 'kakao',
    title: '카카오톡',
  },
  {
    image: <ShareFacebook />,
    onClick: () => {
      const url = encodeURIComponent(window.location.href);
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        'popup',
        'width=400, height=600',
      );
    },
    platform: 'fb',
    title: '페이스북',
  },
  {
    image: <ShareX />,
    onClick: () => {
      const url = encodeURIComponent(window.location.href);
      window.open(`https://x.com/intent/post?url=${url}`, 'popup', 'width=400, height=600');
    },
    platform: 'x',
    title: 'X',
  },
  {
    image: <ShareBand />,
    onClick: () => {
      const url = window.location.href;
      const content = '뷰업';
      const encodeBody = encodeURIComponent(`${content}\n${url}`);
      const encodeRoute = encodeURIComponent(window.location.href);
      window.open(
        `http://band.us/plugin/share?body=${encodeBody}&route=${encodeRoute}`,
        'popup',
        'width=400, height=600',
      );
    },
    platform: 'band',
    title: '밴드',
  },
];
